module.exports = __webpack_public_path__ + "media/backgrounds/listing_hero-64ee37d7.jpg";